import { Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useField, useFormikContext } from 'formik';
import { FieldProjectSelect, FormInput, FormSelect } from '../../../../components';
import { GenericItem } from '../../../../types/items';
import { selectLists } from '../../../../store/modules/lists/selectors';

const AdjustCreditsForm = () => {
  const lists = useSelector(selectLists);
  const availableKeys = ['admin_adjustment', 'production_fee', 'package'];
  const [sourceField] = useField({ name: 'source' });
  const [userId] = useField({ name: 'user_id' });
  const creditQty = useField({ name: 'video_credits_qty' })[0].value;
  const isProjectFeeSelected = sourceField.value === 'production_fee';
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    if (!isProjectFeeSelected) {
      setFieldValue('project_id' as never, -1);
    } else {
      if (creditQty > 0) {
        setFieldValue('video_credits_qty' as never, creditQty * -1);
      }
    }
  }, [isProjectFeeSelected, setFieldValue, creditQty]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <FormSelect
          label="Adjustment Type"
          name="source"
          items={lists.data ? lists.data['credit-sources']
            .filter((item) => availableKeys.includes(item.key.toString()))
            .map((item):GenericItem<number> => ({ id: item.key, title: item.value })) : null}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormInput name="video_credits_qty" label="Credit Quantity" type="number" />
      </Grid>
      {isProjectFeeSelected
        && (
          <Grid item xs={12} sm={6}>
            <FieldProjectSelect userOwnerId={userId.value} name="project_id" label="Project" />
          </Grid>
        )}
      <Grid item xs={12}>
        <FormInput name="note" label="Note" type="textarea" />
      </Grid>
    </Grid>
  );
};

export default AdjustCreditsForm;
